import { modulosWeb } from './modulos-web';
import { useSessao } from './sessao';

/**
 * Ajustes do CRM 27/10 (C2, C15, K3): o "Atalho de tarefas" publicado por um módulo instalado (`ModuloWeb.atalhoTarefas`,
 * hoje o Pipeline), para os cabeçalhos de Empresas, Contatos e Comercial. Sem o módulo instalado, não aparece nada.
 */
export function AtalhoDeTarefas() {
  const s = useSessao();
  const m = modulosWeb.find((x) => x.atalhoTarefas && s.instalado(x.slug));
  if (!m) return null;
  const C = m.atalhoTarefas!;
  return <C />;
}
